import { APP_URL } from "./Config";

const BaseUrl = APP_URL; // Set App url

// Enhanced API structure for better organization
export const APIs = {
    // Authentication APIs
    auth: {
        requestOtp: BaseUrl + "/api/auth/request-otp",
        loginWithOtp: BaseUrl + "/api/auth/login-with-otp",
        validateToken: BaseUrl + "/api/auth/validate-token",
        refreshToken: BaseUrl + "/api/auth/refresh-token"
    },    // Applicant Authentication APIs
    applicant: {
        register: BaseUrl + "/api/apply/register",
        verifyRegistration: BaseUrl + "/api/apply/verify-registration",
        requestLoginOtp: BaseUrl + "/api/apply/login/request-otp",
        verifyLoginOtp: BaseUrl + "/api/apply/login/verify-otp",
        getForms: BaseUrl + "/api/apply/forms",
        submitApplication: BaseUrl + "/api/apply/submit",
        getMyApplications: {
            undergraduate: (submittedBy) => BaseUrl + `/api/apply/student/under/graduate/list/by/user/${encodeURIComponent(submittedBy)}`,
            graduate: (submittedBy) => BaseUrl + `/api/apply/student/graduate/list/by/user/${encodeURIComponent(submittedBy)}`,
            shortCourse: (submittedBy) => BaseUrl + `/api/apply/student/short/course/list/by/user/${encodeURIComponent(submittedBy)}`
        }
    },    // Group Management APIs
    groups: {
        list: BaseUrl + "/api/v1/groups",
        create: BaseUrl + "/api/v1/groups",
        delete: (groupName) => BaseUrl + `/api/v1/groups/${groupName}`,
        view: (groupName) => BaseUrl + `/api/v1/groups/${groupName}`,
        addSubgroup: (parentGroupName) => BaseUrl + `/api/v1/groups/${parentGroupName}/subgroups`,
        addMember: (groupName) => BaseUrl + `/api/v1/groups/${groupName}/members`,
        removeMember: (groupName) => BaseUrl + `/api/v1/groups/${groupName}/members`
    },

    // User Management APIs
    users: {
        list: BaseUrl + "/api/v1/users",
        create: BaseUrl + "/api/v1/users"
    },

    // Applicant Notices APIs
    notices: {
        active: BaseUrl + "/api/notices/active",
        forPage: (page) => BaseUrl + `/api/notices/page/${page}`,
        admin: {
            all: BaseUrl + "/api/notices/admin/all",
            create: BaseUrl + "/api/notices/admin/create",
            update: (noticeId) => BaseUrl + `/api/notices/admin/${noticeId}`,
            delete: (noticeId) => BaseUrl + `/api/notices/admin/${noticeId}`,
            toggleStatus: (noticeId) => BaseUrl + `/api/notices/admin/${noticeId}/toggle-status`
        }
    },

    // Application Forms Management
    applicationForms: {
        list: BaseUrl + "/api/applications/forms/student/list",
        listPublished: BaseUrl + "/api/applications/forms/student/list/published",
        create: BaseUrl + "/api/applications/forms/student/create",
        archive: BaseUrl + "/api/applications/forms/student/archive",
        update: BaseUrl + "/api/applications/forms/student/update",
        publish: BaseUrl + "/api/applications/forms/student/publish",
        getById: BaseUrl + "/api/applications/forms/student/show/"
    },

    // Student Applications
    applications: {        undergraduate: {
            create: BaseUrl + "/api/apply/student/under/graduate/create",
            list: BaseUrl + "/api/apply/student/under/graduate/list",
            getById: BaseUrl + "/api/apply/student/under/graduate/list/by/",
            update: BaseUrl + "/api/apply/student/under/graduate/update",
            archive: BaseUrl + "/api/apply/student/under/graduate/archive",
            updateStatus: BaseUrl + "/api/apply/student/under/graduate/update-status"
        },        graduate: {
            create: BaseUrl + "/api/apply/student/graduate/create",
            list: BaseUrl + "/api/apply/student/graduate/list",
            getById: BaseUrl + "/api/apply/student/graduate/list/by/",
            update: BaseUrl + "/api/apply/student/graduate/update",
            archive: BaseUrl + "/api/apply/student/graduate/archive",
            updateStatus: BaseUrl + "/api/apply/student/graduate/update-status"
        },        shortCourse: {
            create: BaseUrl + "/api/apply/student/short/course/create",
            list: BaseUrl + "/api/apply/student/short/course/list",
            getById: BaseUrl + "/api/apply/student/short/course/list/by/",
            update: BaseUrl + "/api/apply/student/short/course/update",
            archive: BaseUrl + "/api/apply/student/short/course/archive",
            updateStatus: BaseUrl + "/api/apply/student/short/course/update-status"
        },
        inService: {
            create: BaseUrl + "/api/apply/student/in/service/create",
            list: BaseUrl + "/api/apply/student/in/service/list",
            getById: BaseUrl + "/api/apply/student/in/service/list/by/",
            update: BaseUrl + "/api/apply/student/in/service/update",
            archive: BaseUrl + "/api/apply/student/in/service/archive"
        }
    }
};

// Legacy exports for backward compatibility (to be phased out)
export const APIAuthRequestOTP = APIs.auth.requestOtp;
export const APIAuthLogin = APIs.auth.loginWithOtp;
export const APIAuthValidateToken = APIs.auth.validateToken;
export const APIAuthRefreshToken = APIs.auth.refreshToken;

// Application Forms legacy exports
export const APIApplicationFormList = APIs.applicationForms.list;
export const APIApplicationFormListPublished = APIs.applicationForms.listPublished;
export const APIApplicationFormCreate = APIs.applicationForms.create;
export const APIApplicationFormUpdate = APIs.applicationForms.update;
export const APIApplicationFormArchive = APIs.applicationForms.archive;
export const APIApplicationFormPublish = APIs.applicationForms.publish;
export const APIApplicationFormListById = APIs.applicationForms.getById;

// Undergraduate application legacy exports
export const APIAppUnderGraduateCreate = APIs.applications.undergraduate.create;
export const APIAppUnderGraduateList = APIs.applications.undergraduate.list;
export const APIAppUnderGraduateListById = APIs.applications.undergraduate.getById;
export const APIAppUnderGraduateUpdate = APIs.applications.undergraduate.update;
export const APIAppUnderGraduateArchive = APIs.applications.undergraduate.archive;

// Graduate application legacy exports
export const APIAppGraduateCreate = APIs.applications.graduate.create;
export const APIAppGraduateList = APIs.applications.graduate.list;
export const APIAppGraduateListById = APIs.applications.graduate.getById;
export const APIAppGraduateUpdate = APIs.applications.graduate.update;
export const APIAppGraduateArchive = APIs.applications.graduate.archive;

// Short Course application legacy exports
export const APIAppShortCourseCreate = APIs.applications.shortCourse.create;
export const APIAppShortCourseList = APIs.applications.shortCourse.list;
export const APIAppShortCourseListById = APIs.applications.shortCourse.getById;
export const APIAppShortCourseUpdate = APIs.applications.shortCourse.update;
export const APIAppShortCourseArchive = APIs.applications.shortCourse.archive;

// In-Service application legacy exports
export const APIAppInServiceCreate = APIs.applications.inService.create;
export const APIAppInServiceList = APIs.applications.inService.list;
export const APIAppInServiceListById = APIs.applications.inService.getById;
export const APIAppInServiceUpdate = APIs.applications.inService.update;
export const APIAppInServiceArchive = APIs.applications.inService.archive;

